import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
  aiLessons: [],
  count: 0,
  pageIndex: 1,
  pageSize: 10
};

const aiLessonslice = createSlice({
  name: 'classroom',
  initialState,
  reducers: {
    setAiLessons(state, action) {
      return {
        ...state,
        aiLessons: action.payload
      };
    },
    setAiLessonTableCount(state, action) {
      state.count = action.payload;
    },
    setAiLessonPageIndex(state, action) {
      state.pageIndex = action.payload;
    },
    setAiLessonPageSize(state, action) {
      state.pageSize = action.payload;
    },
    delAiLesson(state, action) {
      const arr = state.aiLessons.filter((item: { _id: any }) => item._id !== action.payload);
      return {
        ...state,
        aiLessons: arr
      };
    },
    resetStateAiLesson: (state) => {
      return initialState;
    }
  }
});

export const { setAiLessons, setAiLessonTableCount, delAiLesson, setAiLessonPageSize, setAiLessonPageIndex, resetStateAiLesson } =
  aiLessonslice.actions;

export default aiLessonslice.reducer;
